<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium"
                style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Enrollment</span>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="width: 100%;">
                <mat-accordion [displayMode]="'flat'" [multi]="true" class="mat-elevation-z0">
                    <mat-expansion-panel *ngIf="enrollmentDetails.length > 0" [expanded]="true" class="mat-elevation-z0"
                        style="border-bottom-style: solid;border-bottom-width: 1px;border-bottom-color: lightgray;">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Details
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <!-- Content Area -->
                        <div style="width: 100%">
                            <div style="display: flex; flex: 1; flex-direction: column; padding-left: 12px">
                                <div style="display: flex; flex: 1; padding-bottom: 5px">
                                    <div class="row-detail-label" style="flex: 1">Prior District</div>
                                    <div style="display: flex; flex: 3">{{enrollmentDetails[0].PriorDistrict}}</div>
                                </div>
                                <div style="display: flex; flex: 1; padding-bottom: 5px">
                                    <div class="row-detail-label" style="flex: 1">Include in class Rank</div>
                                    <div style="display: flex; flex: 3">{{enrollmentDetails[0].IncludeInClassRank ? 'Y'
                                        : 'N'}}</div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="enrollmentHistory.length > 0" [expanded]="true"
                        class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                History
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-table style="width: 100%;" multiTemplateDataRows [dataSource]="angularMatData"
                                class="mat-elevation-z0">

                                <!-- Year Column -->
                                <ng-container matColumnDef="year">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Year</span>
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.AcademicYearDesc}}</mat-cell>
                                </ng-container>

                                <!-- School Column -->
                                <ng-container matColumnDef="school">
                                    <mat-header-cell *matHeaderCellDef style="flex: 4"><span translate>School</span>
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 4">{{e.SchoolName}}</mat-cell>
                                </ng-container>

                                <!-- Grade Column -->
                                <ng-container matColumnDef="grade">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Grade</span>
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.GradeLevel}}</mat-cell>
                                </ng-container>

                                <!-- Grade Column -->
                                <ng-container matColumnDef="enrolled">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Enrolled</span>
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.EnrolledDate | date:'MM/dd/yy'}}
                                    </mat-cell>
                                </ng-container>


                                <!-- More Column -->
                                <ng-container matColumnDef="more">
                                    <mat-header-cell *matHeaderCellDef
                                        style="min-width:68px;max-width:68px;text-align:center;" class="print-ignore">
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let AH"
                                        style="min-width:68px;max-width:68px;justify-content: center;"
                                        class="print-ignore">
                                        <span aria-label="Expand row for more details">
                                            <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                                class="material-icons" aria-hidden="true"></i>
                                        </span>
                                    </mat-cell>
                                </ng-container>

                                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                <ng-container matColumnDef="expandedDetail">
                                    <!-- Detail row can have standard html or another Angular Material table -->
                                    <mat-cell *matCellDef="let enrollmentRecord" [attr.colspan]="historyColumns.length"
                                        style="width:100%;">
                                        <div style="flex: 1; display: flex;" *ngIf="angularMatData.checkVisible(enrollmentRecord)">
                                            <div style="display: flex; flex: 1; flex-direction: column">
                                                <div class="row-detail-label"
                                                    style="display: flex; flex: 1; padding-bottom: 5px">Enrollment Code
                                                </div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.EnrollmentCode}}
                                                </div>
                                            </div>
                                            <div style="display: flex; flex: 2; flex-direction: column">
                                                <div class="row-detail-label"
                                                    style="display: flex; flex: 1; padding-bottom: 5px">FTE</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.MembershipCode}}
                                                </div>
                                            </div>
                                            <div style="display: flex; flex: 1; flex-direction: column">
                                                <div class="row-detail-label"
                                                    style="display: flex; flex: 1; padding-bottom: 5px">Withdrawal</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.WithdrawalDate |
                                                    date: 'MM/dd/yy'}}</div>
                                            </div>
                                            <div style="display: flex; flex: 1; flex-direction: column">
                                                <div class="row-detail-label"
                                                    style="display: flex; flex: 1; padding-bottom: 5px">Code</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.WithdrawalCode}}
                                                </div>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="historyColumns; sticky: false"></mat-header-row>
                                <!-- Data rows -->
                                <mat-row *matRowDef="let row; columns: historyColumns; let i = index;"
                                    id="AHdataRow{{i}}" tabindex="0"
                                    [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                                    [ngClass]="{'pastEnrollment' : row.IsCurrent == false}"
                                    style="padding:0;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                                    (keydown)="rowKeyPress($event, row)">
                                </mat-row>
                                <!-- Detail row -->
                                <!-- 'overflow: hidden' is required for animation to render properly -->
                                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                    [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"
                                    (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
                                    (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
                                    style="overflow: hidden;">
                                </mat-row>
                            </mat-table>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</mat-card>